import {
  BusinessState,
  DataState,
  ProductQuantitiesChange,
} from '../../models';

import deliveryItemsToQuantityChanges from './delivery-items-quantity-changes';
import { productQuantitiesBusiness } from './quantities-change/product-quantity.reducer';

/**
 *
 * @param fromShop Key of the source shop accountId-addressId
 * @param toShop Key of the target shop accountId-addressId
 * @param state current state
 */
export function copyToShopBusiness(
  fromShop: string,
  toShop: string,
  state: BusinessState,
  data: DataState,
): BusinessState {
  const sourceShopItems = state.deliveryItems[fromShop];
  if (!sourceShopItems || !Object.keys(sourceShopItems).length) {
    return state;
  }

  // replicates the data from the source
  const changes: ProductQuantitiesChange[] = deliveryItemsToQuantityChanges(
    sourceShopItems,
    toShop,
  );

  return productQuantitiesBusiness(state, { changes, data });
}
